module.exports = __webpack_public_path__ + "static/media/nithan_f_thumb.072d0d7c.jpg";